export default __webpack_public_path__ + "static/media/seo.6b411cc3.jpg";